const localCache = window.localStorage

/**
 * 从window.localStorage取值
 * @param {String} key
 * @param {Boolean} toJson
 */
function getLocalItem(key, toJson){
	if(localCache){
		const cacheString = localCache.getItem(key) || ''
		return toJson ? toJsonObject(cacheString) : cacheString
	}
	return ''
}

/**
 * 往window.localStorage设置key和value
 * @param {String} key
 * @param {Object|String|Number|Boolean} val
 */
function setLocalItem(key, val){
	if(localCache && key){
		localCache.setItem(key, toJsonString(val))
	}
}

function removeLocalItem(key){
	if(localCache && key){
		window.localStorage.removeItem(key)
	}
}

/**
 * 字符串转json对象
 * @param {String} str
 */
function toJsonObject(str){
	let result = {}, type = typeof str
	if(type === 'string'){
		try{
			result = JSON.parse(str)
		}catch(err){
			console.warn('String to JSON Error:' + err, str)
		}
	}else if(type === 'object'){
		result = str 
	}
	return result
}

/**
 * json对象转字符串
 * @param {Object} obj
 */
function toJsonString(obj){
	let result = '', type = typeof obj
	switch(type){
		case 'string': {
			result = obj
			break
		};
		case 'object': {
			try{
				result = JSON.stringify(obj)
			}catch(err){
				console.error('Object to String Error:' + err)
			}
			break
		};
		case 'boolean': {
			result = obj
			break
		};
		case 'number': {
			result = String(obj)
			break
		};
	}
	return result
}

/**
 * 字符串转Base64
 * @param {Any} str
 */
function string2base64(str){
	return str ? btoa(str) : ''
}

function parseQuery(key){
	let query = location.search.slice(1).split('&'), search = '', i = 0
	for(i; i < query.length; i ++){
		const item = query[i].split('=')
		if(item[0] == key){
			return item[1]
		}
	}
	return ''
}

/**
 * Base64转字符串
 * @param {String} str
 */
function base64toString(str){
	try{
		str = atob(str)
	}catch(err){
		//console.error('base64 translate failed:' + str)
	}
	return str 
}

function getDate(date, isFull){
	date = date ? (date instanceof Date ? date : new Date(date)) : new Date()
	const year = date.getFullYear()
	const month = Number.parseInt(date.getMonth()) + 1
	const day = Number.parseInt(date.getDate())
	const week = Number.parseInt(date.getDay() + 1)
	const hour = date.getHours()
	const min = date.getMinutes()
	const sec = date.getSeconds()
	return {
		year,
		month: isFull ? String(month).padStart(2, '0') : month,
		day: isFull ? String(day).padStart(2, '0') : day,
		week,
		hour: isFull ? String(hour).padStart(2, '0') : hour,
		min: isFull ? String(min).padStart(2, '0') : min,
		sec: isFull ? String(sec).padStart(2, '0') : sec
	}
}

export default {
	getLocalItem,
	setLocalItem,
	removeLocalItem,
	string2base64,
	base64toString,
	parseQuery,
	getDate
}